/** Boîte de dialogue de confirmation (modale, accessible, style de l'application). */
import { h } from './dom';

export interface ConfirmLabels {
  readonly confirm: string;
  readonly cancel: string;
}

export function confirmDialog(message: string, labels: ConfirmLabels): Promise<boolean> {
  return new Promise((resolve) => {
    const previousFocus = document.activeElement as HTMLElement | null;
    const title = h('p', { class: 'dialog-message', id: 'confirm-message' }, message);
    const cancel = h(
      'button',
      { type: 'button', class: 'button secondary', testid: 'confirm-cancel' },
      labels.cancel,
    );
    const confirm = h(
      'button',
      { type: 'button', class: 'button danger', testid: 'confirm-ok' },
      labels.confirm,
    );
    const box = h(
      'div',
      {
        class: 'card dialog',
        role: 'dialog',
        'aria-modal': 'true',
        'aria-labelledby': 'confirm-message',
      },
      title,
      h('div', { class: 'actions' }, cancel, confirm),
    );
    const overlay = h('div', { class: 'dialog-overlay' }, box);

    const close = (answer: boolean): void => {
      document.removeEventListener('keydown', onKey);
      overlay.remove();
      previousFocus?.focus();
      resolve(answer);
    };
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') close(false);
    };
    cancel.addEventListener('click', () => {
      close(false);
    });
    confirm.addEventListener('click', () => {
      close(true);
    });
    document.addEventListener('keydown', onKey);
    document.body.append(overlay);
    cancel.focus();
  });
}
